import * as React from 'react'
import { FC } from 'react'
import { ButtonCompleted } from '../atoms'

type Props = {
  onOpenNestedDialog: (completeView: boolean) => void
  appointmentId: string
}
export const MarkCompleted: FC<Props> = (props) => {
  const { onOpenNestedDialog, appointmentId } = props

  return (
    <ButtonCompleted
      variant="contained"
      color="primary"
      onClick={() => onOpenNestedDialog(true)}
      data-test-id={`mark-completed-button-${appointmentId}`}
    >
      Mark as Completed
    </ButtonCompleted>
  )
}

MarkCompleted.displayName = 'MarkCompleted'
